import React, { Component } from 'react';
import { APP_URL_API } from '../../../../setup/configs'
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import Modal from '../../../../ui/modal/Modal';
import axios from 'axios';

export default class Alert extends Component {
	constructor(props) {
        super(props);
        this.state = {
            alertTitle: '',
            alertId: null,
            editorState: EditorState.createEmpty(),
            accept: false,
            showModal: false,
            showMessage: false
        }
    }
    componentDidMount() {
		this.getAlertMessage();
	}
	getAlertMessage = () => {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'alertMessage/latestActiveNotConsented';
        	this.serverRequest =
	            axios
	                .get(url, {headers: config})
	                .then(function(result) {
	                	if(result.data!=="") {
	                	this.setState({
	                		showMessage: true,
	                		alertTitle: result.data.data.title,
	                		alertId: result.data.data.id,
	                		editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(result.data.data.message)))
	                	})
	                }
	                }.bind(this))
	}

	giveConsent() {
		const token = sessionStorage.getItem('id_token');
        const config = { 'Authorization': 'Bearer '+ token};
        const url = APP_URL_API + 'alertMessage/' + this.state.alertId + '/consent/' + this.props.organizationId;
        const data = {};
        data._method = 'patch';

        	this.serverRequest =
	            axios
	                .post(url, data, {headers: config})
	                .then(function(result) {
	                	this.setState({
	                		showMessage: false,
	                		showModal: false
	                	})
	                }.bind(this))
    }

	onChange = (e) => {
    	this.setState({
        	[e.target.name]: e.target.checked,
        	showModal: true
    	})
	}

	onSubmit = () => {
		this.giveConsent();
	}

	createMarkup = (html) => { return {__html: html}; };

	onToggleModal = () => {
        if(this.state.showModal) {
            this.setState({
                showModal: false,
                accept: false
            });
        } else {
            this.setState({
                showModal: true
            })
        }
    }

	render() {
		if(this.state.showMessage) {
			const rawContentState = convertToRaw(this.state.editorState.getCurrentContent());
			const markup = draftToHtml(
			  rawContentState
			);
			return(
				<div>
					<div className="alertBox">
						<div dangerouslySetInnerHTML={this.createMarkup(markup)} />
					</div>
					<div className="alertConsent"><input type="checkbox" name="accept" onChange={this.onChange} checked={this.state.accept} /> Tro og love erklæring: alle oplysninger på siden er opdateret og korrekte.</div>
					<Modal visible={this.state.showModal}>
						<p>Du bekræfter hermed på tro og love, at alle oplysninger er opdateret og korrekte.</p>
						<div style={{marginTop: '1em'}}>
                        <button type="button" className="button" onClick={() => this.onToggleModal()}>Annuller</button>
                        <button type="button" className="button" onClick={this.onSubmit}>Bekræft</button>
                    </div>
					</Modal>
				</div>
			)
		} else {
			return null
		}
	}
}


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/Alert.js